
const MobileSidebarHeader = ({ appCanal }) => (

  <div className="flex align-items-center gap-2 pt-3 pb-2 px-3 border-bottom-1 surface-border">
    <i className="pi pi-home text-xl text-gray-500"></i>
    <span className="text-base font-semibold text-gray-900">
      {appCanal || "Mi cuenta"}
    </span>

  </div>
);

export default MobileSidebarHeader;
